import { memo } from 'react'
import { bool, oneOf, string } from 'prop-types'
import { colors } from 'theme/colors'
import { Stack, Text } from 'ui/baseComponents'
import { REPORT_VARIANTS } from 'ui/clinicianScreens/Patient/Report/consts'
import StrivePDGuardianIcon from 'assets/img/strivepd-guardian-icon.png'

const BrandedSectionHeader = ({
  borderRadius = 'full',
  showGuardianIcon = false,
  title,
  variant,
}) => {
  const BACKGROUND = {
    guardian: `linear-gradient(91.7deg, ${colors.PRIMARY[1000]}  0.2%, ${colors.VIOLET[600]} 35.57%, ${colors.PURPLE[500]} 101.25%)`,
    strivePD: colors.PRIMARY[1000],
  }

  const GUARDIAN_ICON_WIDTH = '20px'

  const STYLES = {
    sectionHeaderContainer: {
      background:
        variant === REPORT_VARIANTS.guardian
          ? BACKGROUND.guardian
          : BACKGROUND.strivePD,
      borderRadius: borderRadius === 'topOnly' ? '16px 16px 0 0' : '16px',
      padding: '8px 16px ',
    },
    sectionHeaderText: {
      textAlign: 'center',
      paddingLeft: showGuardianIcon ? GUARDIAN_ICON_WIDTH : '0px',
    },
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={STYLES.sectionHeaderContainer}
      data-cy="branded-section-header"
    >
      <Stack sx={{ flexGrow: 1 }}>
        <Text
          color={colors.WHITE}
          variant="head20B"
          component="h2"
          sx={STYLES.sectionHeaderText}
        >
          {title}
        </Text>
      </Stack>
      {showGuardianIcon && (
        <img
          src={StrivePDGuardianIcon}
          alt="StrivePD Guardian Icon"
          height="14px"
          width={GUARDIAN_ICON_WIDTH}
          style={{
            textAlign: 'right',
            marginLeft: 0,
          }}
        />
      )}
    </Stack>
  )
}

export default memo(BrandedSectionHeader)

BrandedSectionHeader.propTypes = {
  borderRadius: oneOf(['topOnly', 'full']),
  showGuardianIcon: bool,
  title: string.isRequired,
  variant: string,
}
